import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";

export default function useResponsive() {
  const theme = useTheme();

  return {
    isXs: useMediaQuery(theme.breakpoints.down("xs")),   // xs < sm
    isSm: useMediaQuery(theme.breakpoints.down("sm")),   // xs, sm
    isMd: useMediaQuery(theme.breakpoints.between("sm", "md")), // sm <= md
    isLg: useMediaQuery(theme.breakpoints.up("md")),     // md >= lg
    isXl: useMediaQuery(theme.breakpoints.up("lg")),     // lg >= xl
  };
}